module.exports = __webpack_public_path__ + "img/bus_orange.552e4db0.svg";